import { Outlet } from "react-router-dom";

/**
 
 * @returns {JSX.Element} The JSX for the Layout component.
 */
const Layout = () => {
  return (
    <div>
      {/* Render the child routes within the Outlet component. */}
      <Outlet />
    </div>
  );
};

export default Layout;
